// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KontaktirajModal_modalWrapper__BBwoq {
  display: flex;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  justify-content: center;
  align-items: center;
}

.KontaktirajModal_modalContainer__z31jY {
  width: 700px;
  height: 480px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  position: relative;
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.KontaktirajModal_modalTitle__ifiVH {
  font-family: "Inter";
  font-size: 26px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  color: #808080;
  position: absolute;
  top: 30px;
}

.KontaktirajModal_modalInput__70SFz {
  width: 450px;
  height: 36px;
  padding: 10px;
  box-sizing: border-box;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  color: #808080;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.KontaktirajModal_modalText__gDd\\+A {
  width: 450px;
  height: 250px;
  resize: none;
  padding: 10px;
  box-sizing: border-box;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  color: #808080;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.KontaktirajModal_modalText__gDd\\+A:focus,
.KontaktirajModal_modalInput__70SFz:focus {
  outline: none;
}

.KontaktirajModal_btnsContainer__-bOlG {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 25px;
  position: absolute;
  bottom: 25px;
}

.KontaktirajModal_cancelButton__4MroZ {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #ebebeb;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #808080;
  cursor: pointer;
}
.KontaktirajModal_nextButton__i1ALE {
  width: 212px;
  height: 52px;
  padding: 8px 16px 8px 16px;
  border-radius: 4px;
  gap: 8px;
  background: #cb9c2d;
  font-family: "Inter";
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: center;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.KontaktirajModal_cancelButton__4MroZ:hover,
.KontaktirajModal_nextButton__i1ALE:hover {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/terapeuti/TerapeutProfil/components/KontaktirajModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".modalWrapper {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1000;\n  justify-content: center;\n  align-items: center;\n}\n\n.modalContainer {\n  width: 700px;\n  height: 480px;\n  background-color: white;\n  border-radius: 10px;\n  padding: 20px;\n  position: relative;\n  z-index: 1001;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.modalTitle {\n  font-family: \"Inter\";\n  font-size: 26px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: #808080;\n  position: absolute;\n  top: 30px;\n}\n\n.modalInput {\n  width: 450px;\n  height: 36px;\n  padding: 10px;\n  box-sizing: border-box;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  color: #808080;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.modalText {\n  width: 450px;\n  height: 250px;\n  resize: none;\n  padding: 10px;\n  box-sizing: border-box;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  color: #808080;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.modalText:focus,\n.modalInput:focus {\n  outline: none;\n}\n\n.btnsContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  gap: 25px;\n  position: absolute;\n  bottom: 25px;\n}\n\n.cancelButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #ebebeb;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n}\n.nextButton {\n  width: 212px;\n  height: 52px;\n  padding: 8px 16px 8px 16px;\n  border-radius: 4px;\n  gap: 8px;\n  background: #cb9c2d;\n  font-family: \"Inter\";\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancelButton:hover,\n.nextButton:hover {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `KontaktirajModal_modalWrapper__BBwoq`,
	"modalContainer": `KontaktirajModal_modalContainer__z31jY`,
	"modalTitle": `KontaktirajModal_modalTitle__ifiVH`,
	"modalInput": `KontaktirajModal_modalInput__70SFz`,
	"modalText": `KontaktirajModal_modalText__gDd+A`,
	"btnsContainer": `KontaktirajModal_btnsContainer__-bOlG`,
	"cancelButton": `KontaktirajModal_cancelButton__4MroZ`,
	"nextButton": `KontaktirajModal_nextButton__i1ALE`
};
export default ___CSS_LOADER_EXPORT___;
